import { all, call, put, takeEvery } from "redux-saga/effects";

import * as t from "./actionType";
import * as a from "./action";

import {
  // recording
  getMeetingRecordingList,
  getMeetingRecordingData,
  dispatchMeetingRecording,
  updateMeetingRecording,
  deleteMeetingRecording,
  retrySummaryMeetingRecording,
  syncMeetingRecording,
  // settings
  getMeetingRecordingSettings,
  updateMeetingRecordingSettings,
} from "../../helpers/fakebackend_helper";

// ---------- RECORDING ----------
function* recordingListSaga() {
  try {
    yield put(a.meetingRecordingListSuccess(yield call(getMeetingRecordingList)));
  } catch (e) {
    yield put(a.meetingRecordingListFail(e));
  }
}
function* recordingDataSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingDataSuccess(yield call(getMeetingRecordingData, data))
    );
  } catch (e) {
    yield put(a.meetingRecordingDataFail(e));
  }
}
function* recordingDispatchSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingDispatchSuccess(
        yield call(dispatchMeetingRecording, data)
      )
    );
  } catch (e) {
    yield put(a.meetingRecordingDispatchFail(e));
  }
}
function* recordingUpdateSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingUpdateSuccess(yield call(updateMeetingRecording, data))
    );
  } catch (e) {
    yield put(a.meetingRecordingUpdateFail(e));
  }
}
function* recordingDeleteSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingDeleteSuccess(yield call(deleteMeetingRecording, data))
    );
  } catch (e) {
    yield put(a.meetingRecordingDeleteFail(e));
  }
}
function* recordingRetrySummarySaga({ data }) {
  try {
    yield put(
      a.meetingRecordingRetrySummarySuccess(
        yield call(retrySummaryMeetingRecording, data)
      )
    );
  } catch (e) {
    yield put(a.meetingRecordingRetrySummaryFail(e));
  }
}
function* recordingSyncSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingSyncSuccess(yield call(syncMeetingRecording, data))
    );
  } catch (e) {
    yield put(a.meetingRecordingSyncFail(e));
  }
}

// ---------- SETTINGS ----------
function* settingsSaga() {
  try {
    yield put(
      a.meetingRecordingSettingsSuccess(yield call(getMeetingRecordingSettings))
    );
  } catch (e) {
    yield put(a.meetingRecordingSettingsFail(e));
  }
}
function* settingsUpdateSaga({ data }) {
  try {
    yield put(
      a.meetingRecordingSettingsUpdateSuccess(
        yield call(updateMeetingRecordingSettings, data)
      )
    );
  } catch (e) {
    yield put(a.meetingRecordingSettingsUpdateFail(e));
  }
}

function* MeetingRecording() {
  yield all([
    takeEvery(t.MEETING_RECORDING_LIST, recordingListSaga),
    takeEvery(t.MEETING_RECORDING_DATA, recordingDataSaga),
    takeEvery(t.MEETING_RECORDING_DISPATCH, recordingDispatchSaga),
    takeEvery(t.MEETING_RECORDING_UPDATE, recordingUpdateSaga),
    takeEvery(t.MEETING_RECORDING_DELETE, recordingDeleteSaga),
    takeEvery(t.MEETING_RECORDING_RETRY_SUMMARY, recordingRetrySummarySaga),
    takeEvery(t.MEETING_RECORDING_SYNC, recordingSyncSaga),
    takeEvery(t.MEETING_RECORDING_SETTINGS, settingsSaga),
    takeEvery(t.MEETING_RECORDING_SETTINGS_UPDATE, settingsUpdateSaga),
  ]);
}

export default MeetingRecording;
